const endpoints = {
	//Config
	createReportTitle: '/reports/config/createReportTitle',
	updateReportTitle: '/reports/config/updateReportTitle',
	updateOrderTitleReport: '/reports/config/updateOrderTitle',
	getReportTitles: '/reports/config/getReportTitles',
	deleteReportTitle: '/reports/config/deleteReportTitle',

	createReport: '/reports/createReport',
	updateReport: '/reports/updateReport',
	createReportPdfFromPreview: '/reports/createReportPdfFromPreview',
	sendReportPdfEmail: '/reports/sendReportPdfEmail',
	getCompanyReports: '/reports/getCompanyReports',
	getReportById: '/reports/getReportById',
	deleteReport: '/reports/deleteReport',
	forceReportHeaderGeneration: '/reports/forceReportHeaderGeneration',
	newReportObservation: '/reports/newReportObservation',

	//Onlyoffice Config Mover
	getEditorConfig: '/onlyoffice/config',

	//Deprecar
	createReportPdfFromPreviewLegacy: '/reports/createReportPdfFromPreviewLegacy',
}
export {endpoints}